<script>
import ItemList from 'Vue/Web/ItemList.vue';

export default {
    components: {
        ItemList,
    },
    props: {
        authCheck: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            currentFilterSelect: '',
            currentKeywordSelect: '',
            filterList: [
                {
                    name: '全部文章',
                    value: '',
                },
                {
                    name: '我的標記',
                    value: 'mark',
                    icon: './img/pic/prompt.svg',
                    authCheck: true,
                },
            ],
        };
    },
    computed: {
        accessibleFilterList() {
            return this.filterList.filter((item) => !item.authCheck || (item.authCheck && this.authCheck));
        },
    },
    mounted() {
    },
    methods: {
        updateFilter(value) {
            this.currentFilterSelect = value;
            this.onChangeFilter();
        },
        onChangeFilter() {
            const url = new URL(window.location.href);

            if (this.currentSortSelect) {
                url.searchParams.set('sort', this.currentSortSelect);
            } else {
                url.searchParams.delete('sort');
            }

            if (this.currentFilterSelect) {
                url.searchParams.set('filter', this.currentFilterSelect);
            } else {
                url.searchParams.delete('filter');
            }
            url.searchParams.delete('keyword');
            url.searchParams.delete('classMetaId');

            window.location.href = url.href;
        },
    },
};
</script>
